import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import GoalStaticTableCell from './GoalStaticTableCell';

const GoalStaticsEmpRow = ({ data, headers }) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={headers.length + 3} align="center" sx={{ py: 3 }}>
          데이터가 없습니다.
        </TableCell>
      </TableRow>
    );
  }

  const cellStyle = {
    border: '1px solid #e0e0e0',
    fontSize: '0.875rem',
    padding: '8px',
  };
  
  const calculateSum = (items, headerRows) => {
    return headerRows.reduce((acc, field) => {
      const key = typeof field === 'object' ? (field.id || field.key) : field;
      const sum = items.reduce((total, item) => {
        const val = item?.[key];
        const num = (val !== undefined && val !== null && val !== '') ? Number(val) : 0;
        return total + (isNaN(num) ? 0 : num);
      }, 0);
      acc[key] = sum;
      return acc;
    }, {});
  };

  const hqCalculatedTotals = data.map((hq, index) => {
    const isLastRow = index === data.length - 1 || hq.id === 'total';

    if (isLastRow) return null; 

    const dpSubTotalRows = hq.children?.map(dp => 
      dp.children?.find(emp => emp.name === '소계' || emp.id === 'total')
    ).filter(Boolean) || [];

    return calculateSum(dpSubTotalRows, headers);
  });

  const grandTotalValues = calculateSum(hqCalculatedTotals.filter(Boolean), headers);

  return data.map((hq, index) => {
  const isGrandTotalHq = hq.id === 'total' || index === data.length - 1;
  
  const currentTotalValues = isGrandTotalHq ? grandTotalValues : hqCalculatedTotals[index];
  const enrichedHq = { ...hq, ...currentTotalValues };

  // 1. [추가] 특정 ID를 제외하고 rowSpan을 실시간으로 재계산한 새로운 hq 객체를 만듭니다.
  const EXCLUDE_IDS = ['97d03a62-9a55-4ead-a0fd-313234b11e73', '8c75f20f-1e93-4900-9884-279a62226f55'];
  
  const cleanedHq = hq ? {
    ...hq,
    children: hq.children?.map(dp => {
      const filteredEmployees = dp.children?.filter(emp => !EXCLUDE_IDS.includes(emp.id)) || [];
      return {
        ...dp,
        children: filteredEmployees,
        rowSpan: filteredEmployees.length // 줄어든 부서 직원 수만큼 부서 rowSpan 갱신
      };
    }) || []
  } : null;

  // 본부(hq)의 총 rowSpan도 줄어든 부서들의 rowSpan 합으로 재계산
  if (cleanedHq) {
    cleanedHq.rowSpan = cleanedHq.children.reduce((acc, dp) => acc + (dp.rowSpan || 0), 0);
  }

  // 2. [수정] 원본 hq 대신, 데이터가 정제되고 rowSpan이 맞춰진 cleanedHq를 사용하여 렌더링합니다.
  const rows = cleanedHq?.children?.flatMap((dp, dpIndex) => {
    return dp?.children?.map((emp, empIndex) => {
      const isSubTotal = emp.name === '소계' || emp.id === 'total';

      return (
        <TableRow 
          key={`row-${cleanedHq.id}-${dp.id}-${emp.id}`}
          sx={{ backgroundColor: isSubTotal ? '#f9f9f9' : 'inherit' }}
        >
          {dpIndex === 0 && empIndex === 0 && (
            <TableCell align="center" rowSpan={cleanedHq.rowSpan} sx={{ ...cellStyle, fontWeight: 'bold', width: '100px', backgroundColor: '#f5f5f5' }}>
              {cleanedHq.name}
            </TableCell>
          )}
          {empIndex === 0 && (
            <TableCell align="center" rowSpan={dp.rowSpan} sx={{ ...cellStyle, width: '110px', backgroundColor: '#f5f5f5' }}>
              {dp.name}
            </TableCell>
          )}
          <TableCell align="center" sx={{ ...cellStyle, width: '80px', fontWeight: isSubTotal ? 'bold' : 'normal' }}>
            {emp.name}
          </TableCell>
          <GoalStaticTableCell data={emp} headerRows={headers} />
        </TableRow>
      );
    });
  }) || [];

  const hqTotalRow = (
    <TableRow 
      key={`total-hq-${hq.id}`} 
      sx={{ backgroundColor: isGrandTotalHq ? '#edf2f7' : '#edf2f7' }}
    >
      <TableCell align="center" colSpan={3} sx={{ ...cellStyle, fontWeight: 'bold' }}>
        {hq.id === 'total' ? hq.name : `${hq.name} 소계`}
      </TableCell>
      <GoalStaticTableCell data={enrichedHq} headerRows={headers} />
    </TableRow>
  );

  return [...rows, hqTotalRow];
});

};

export default GoalStaticsEmpRow;
